module.exports = __webpack_public_path__ + "img/btn-next.01058410.png";